import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import tea from './Assets/tea.png'

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Breadcrumbs from './Breadcrumbs.js'
import favicon from './Assets/logo.png' 
import Pagination from '@mui/material/Pagination';

import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';

// import puerhpic from './Assets/puerh.png';
import dianhongpic from './Assets/dianhongcomp.png'
import biluochunpic from './Assets/biluochuncomp.png'
import dahongpaopic from './Assets/dahongpaocomp.png'
import baihaopic from './Assets/baihaocomp.png'
import huangchapic from './Assets/huangchacomp.png'
import lapsangpic from './Assets/lapsangcomp.png'
import liubaopic from './Assets/liubaocomp.png'
import longjingpic from './Assets/longjingcomp.png'
import puerhpic from './Assets/puerhcomp.png'
import qimenpic from './Assets/qimencomp.png'
import shoumeipic from './Assets/shoumeicomp.png'
import twoolongpic from './Assets/twoolongcomp.png'

function InfoCard(props) {
    const regionInfo = {
        "Yunnan": [
            {
                "Name": "PuErh",
                "Picture":puerhpic,
                "Type": "Dark",
                "Notes": "Woody, Earthy",
                "Description": "A fermented tea often made from centuries-old tea trees (gushu)"
            },
            {
                "Name": "DianHong",
                "Picture":dianhongpic,
                "Type": "Red",
                "Notes": "Woody, Floral?",
                "Description": "Red tea made from large leaves from Yunnan"
            }
        ],
        "GuangXi": [
            {
                "Name": "LiuBao",
                "Picture":liubaopic,
                "Type": "Dark",
                "Notes": "Woody, Earthy",
                "Description": "Also a fermented tea often made from centuries-old tea trees (gushu)"
            }
        ],
        "QiMen": [
            {
                "Name": "QiMen Red Tea",
                "Picture":qimenpic,
                "Type": "Red",
                "Notes": "Red, Earthy",
                "Description": "Famous black tea from QiMen"
            }
        ],
        "FuDing": [
            {
                "Name": "Shoumei",
                "Picture":shoumeipic,
                "Type": "White",
                "Notes": "Floral, Caramel",
                "Description": "Yummy white tea"
            },
            {
                "Name": "Silver Needles",
                "Picture":baihaopic,
                "Type": "White",
                "Notes": "Floral, Caramel",
                "Description": "Yummy white tea"
            }
        ],
        "WuYi": [
            {
                "Name": "Lapsang Souchong",
                "Picture":lapsangpic,
                "Type": "Red",
                "Notes": "Smoky, Fruity, Floral",
                "Description": "The oldest black tea; sometimes smoked with pine giving it a smoky aroma"
            },
            {
                "Name": "DaHongPao",
                "Picture":dahongpaopic,
                "Type": "Oolong",
                "Notes": "Fruity, Sweet, Floral",
                "Description": "One of the most exclusive trees"
            },

        ],
        "Taiwan": [
            {
                "Name": "BiLuoChun",
                "Picture":biluochunpic,
                "Type": "Green",
                "Notes": "Green",
                "Description": "Famous green tea from SanXia, originated from SuZHou"
            },
            {
                "Name": "High Mountain Oolong",
                "Picture":twoolongpic,
                "Type": "Oolong",
                "Notes": "Floral",
                "Description": "A lightly oxidized oolong cultivated at high altitudes"
            }
        ],
        "XiHu": [
            {
                "Name": "LongJing Green",
                "Picture":longjingpic,
                "Type": "Green",
                "Notes": "Green",
                "Description": "Famous green tea, delish"
            }
        ],
        "YueYang": [
            {
                "Name": "YueYang Yellow Tea",
                "Picture":huangchapic,
                "Type": "Yellow",
                "Notes": "Yellow",
                "Description": "Famous Yellow tea, delish"
            }
        ],
        // "SuZhou": [
        //     {
        //         "Name": "SuZhou BiLuoChun",
        //         "Type": "Green", // TODO: add icon too.
        //         "Picture":'./Assets/logo.png',
        //         "Notes": "Green",
        //         "Description": "Famous green tea from SuZhou, also grown in SanXia"
        //     }
        // ]
    };

    useEffect(() => {
        // console.log(props)
    }, [])

    var name = regionInfo[props.regionChosen][props.regionIndex]["Name"]

	return (
        <Card sx={{maxWidth:300}}>

            <CardContent  >
                
                    <Typography variant="h5">
                        <b>{props.regionChosen}</b>
                    </Typography>
                <Stack sx={{alignItems:"center", justifyContent:"center"}}>
                    <img src={regionInfo[props.regionChosen][props.regionIndex]["Picture"]} align='center' width="150px" sx={{ml:"auto", mr:"auto"}} />
                </Stack>
                
                <Typography variant="h6">{name !== undefined ? name : "defaultRegion"}</Typography>
                <Typography variant="body2">Notes: {regionInfo[props.regionChosen][props.regionIndex]["Notes"]}</Typography>
                {/* for notes, use icons with tooltips to make it charming. */}
                <Typography variant="body2">
                    Type: {regionInfo[props.regionChosen][props.regionIndex]["Type"]}
                </Typography>
                <Typography variant="body2">
                    Description: {regionInfo[props.regionChosen][props.regionIndex]["Description"]}
                </Typography>

                <Stack sx={{alignItems:"center", justifyContent:"center", }}>
                    <Pagination 
                    page={props.regionIndex+1}
                    onChange={(e, page) => props.setRegionIndex(page-1)}
                    sx={{ mt:1}}
                    count={regionInfo[props.regionChosen].length}
                    boundaryCount={1}
                    hideNextButton
                    hidePrevButton
                    />
                </Stack>
                
            </CardContent>

        </Card>
	)
}

export default InfoCard;